"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validator = exports.mapQueryFields = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _validator = _interopRequireDefault(require("validator"));
var _set = _interopRequireDefault(require("lodash/set"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var funcs = Object.entries(_validator["default"]).filter(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    fn = _ref2[1];
  return typeof fn === 'function';
}).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    key = _ref4[0],
    fn = _ref4[1];
  return _defineProperty({}, key, function () {
    for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
      options[_key] = arguments[_key];
    }
    return function (str) {
      return fn.apply(void 0, [str].concat(options));
    };
  });
});
var validator = exports.validator = Object.assign.apply(Object, [{
  isDate: function isDate() {
    return function (str) {
      return (0, _moment["default"])(str, 'YYYY-MM-DD').isValid();
    };
  },
  isTime: function isTime() {
    return function (str) {
      return (0, _moment["default"])(str, 'HH:mm').isValid();
    };
  }
}].concat(_toConsumableArray(funcs)));
var mapQueryFields = exports.mapQueryFields = function mapQueryFields(fields, mapping) {
  var data = {};
  Object.entries(mapping).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      key = _ref7[0],
      rule = _ref7[1];
    var valid = rule.validator,
      sanitizer = rule.sanitizer,
      stateField = rule.stateField;
    var value = fields[key];
    if (value === undefined) {
      return {};
    }
    if (valid && !valid(value)) {
      throw new Error("Failed to validate query field: ".concat(key, " = ").concat(value));
    }
    value = sanitizer ? sanitizer(value) : value;
    if (typeof stateField === 'string') {
      (0, _set["default"])(data, stateField, value);
    } else {
      stateField.parse(value, data);
    }
  });
  return data;
};